import { z } from 'zod'

import { CreditCardTypeZ } from './creditCard'

// eslint-disable-next-line no-restricted-syntax
export enum VirtualPaymentAutomationStatus {
	PendingValidation = 'PENDING_VALIDATION',
	Active = 'ACTIVE',
	Deactivated = 'DEACTIVATED',
}

// eslint-disable-next-line no-restricted-syntax
export enum VirtualPaymentAutomationUsageAllowedFor {
	Country = 'COUNTRY',
	InvoiceProfile = 'INVOICE_PROFILE',
}

export const VirtualPaymentAutomationCreationPayloadZ = z.object({
	card_type: CreditCardTypeZ.nullable(),
	card_pool_name: z.string(),
	client_id: z.string(),
	usage_allowed_for: z.enum(VirtualPaymentAutomationUsageAllowedFor),
	available_only_for_travel_arrangers: z.boolean(),

	permitted_for_flights: z.boolean(),
	permitted_for_trains: z.boolean(),
	permitted_for_hotels: z.boolean(),
	permitted_for_cars: z.boolean(),
	permitted_for_fees: z.boolean(),

	care_of_name: z.string().max(200).nullable(),
	payment_instructions: z.string().max(200).nullable(),
})

export type VirtualPaymentAutomationCreationPayload = z.infer<typeof VirtualPaymentAutomationCreationPayloadZ>

export const VirtualPaymentAutomationIdZ = z.number()

export type VirtualPaymentAutomationId = z.infer<typeof VirtualPaymentAutomationIdZ>

export const VirtualPaymentAutomationZ = VirtualPaymentAutomationCreationPayloadZ.extend({
	id: VirtualPaymentAutomationIdZ,
	status: z.enum(VirtualPaymentAutomationStatus),
	created_dt: z.string(),
	company_id: z.number(),
	invoice_profile: z.object({ id: z.number(), display_name: z.string() }),
})

export type VirtualPaymentAutomation = z.infer<typeof VirtualPaymentAutomationZ>

export interface WithVirtualPaymentAutomationId {
	virtual_payment_automation_id: number
}

export interface WithVirtualPaymentAutomations {
	virtual_payment_automations: VirtualPaymentAutomation[] | null
}
